import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const titleRef = useRef(null);
  const [isTitleWrapped, setIsTitleWrapped] = useState(false);

  useEffect(() => {
    const checkWrap = () => {
      if (titleRef.current) {
        // Uma linha tem em média 28px de altura. Se a altura passar de 35px, o texto quebrou de linha.
        setIsTitleWrapped(titleRef.current.offsetHeight > 35);
      }
    };

    // Verifica o tamanho assim que o cartão carrega na tela e também se o usuário girar/redimensionar o celular
    checkWrap();
    window.addEventListener('resize', checkWrap);
    return () => window.removeEventListener('resize', checkWrap);
  }, [product.name]);

  return (
    <div 
      className="text-center group flex flex-col h-full"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image with border like original site */}
      <Link to={`/produto/${product.id}`} className="block">
        <div className="aspect-square overflow-hidden rounded-lg mb-4 border-4 border-[#DAA520] bg-[#F5F0E6] shadow-xl hover:shadow-2xl transition-shadow duration-300">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            loading="lazy"
          />
        </div>
      </Link>

      {/* Title - Marrom */}
      <Link to={`/produto/${product.id}`}>
        <h3 
          ref={titleRef}
          className="text-lg md:text-xl font-semibold text-[#8B4513] mb-2 hover:text-[#DAA520] transition-colors"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          {product.name}
        </h3>
      </Link>

      {/* Price */}
      <div className="text-[#4A3728] font-medium mb-4 flex-grow">
        {isTitleWrapped ? (
          // Título quebrou para 2 linhas: Preço e envio ficam juntinhos (ocupa 1 linha)
          <div>
            {product.price_display} <span className="text-[#6B5344]">+ envio</span>
          </div>
        ) : (
          // Título tem só 1 linha: Envio desce para preencher o espaço que sobrou (ocupa 2 linhas)
          <div className="flex flex-col items-center">
            <span>{product.price_display}</span>
            <span className="text-[#6B5344] -mt-1">+ envio</span>
          </div>
        )}
      </div>

      {/* Button - Marrom */}
      <Link
        to={`/produto/${product.id}`}
        className="inline-block w-full bg-[#8B4513] text-[#F5F0E6] px-6 py-2.5 rounded hover:bg-[#6B3410] transition-colors font-medium mt-auto"
        data-testid={`saiba-mais-btn-${product.id}`}
      >
        Saiba mais
      </Link>
    </div>
  );
};

export default ProductCard;
